import { render } from "./adminHome.vue?vue&type=template&id=54400bde&scoped=true"
import script from "./adminHome.vue?vue&type=script&lang=js"
export * from "./adminHome.vue?vue&type=script&lang=js"

import "./adminHome.vue?vue&type=style&index=0&id=54400bde&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54400bde"]])

export default __exports__